const spiner = document.querySelector('.js-spiner');
import { Spinner } from 'spin.js';
const opts = {
  lines: 12, // The number of lines to draw
  length: 50, // The length of each line
  width: 24, // The line thickness
  radius: 67, // The radius of the inner circle
  scale: 0.7, // Scales overall size of the spinner
  corners: 1, // Corner roundness (0..1)
  speed: 1, // Rounds per second
  rotate: 0, // The rotation offset
  animation: 'spinner-line-fade-more', // The CSS animation name for the lines
  direction: 1, // 1: clockwise, -1: counterclockwise
  color: '#f50000', // CSS color or array of colors
  fadeColor: 'transparent', // CSS color or array of colors
  top: '50%', // Top position relative to parent
  left: '50%', // Left position relative to parent
  shadow: '0 0 1px transparent', // Box-shadow for the lines
  zIndex: 2000000000, // The z-index (defaults to 2e9)
  className: 'spinner', // The CSS class to assign to the spinner
  position: 'absolute', // Element positioning
};
  const spinner = new Spinner(opts);

  export function spinerPlay() {
    spinner.spin(spiner);
  }
  
  export function spinerStop() {
    setTimeout(() => {
      spinner.stop(); 
    }, 300)
       
  }

 
